import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=3ba47d5f&scoped=true&"
import script from "./accountDetail.vue?vue&type=script&lang=js&"
export * from "./accountDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountDetail.vue?vue&type=style&index=0&id=3ba47d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba47d5f",
  null
  
)

export default component.exports